<template>
  <section>
    <h1>Erreur 404: page non trouvée</h1>
    <b-button to="/" variant="primary">Retour accueil</b-button>
  </section>
</template>

<script>
export default {
  name: "PageNotFound"
};
</script>

<style>
div {
  text-align: center;
}
h1 {
  color: #2cb62c;
  font-size: 2em;
  margin-bottom: 1em;
}
</style>